document.addEventListener('DOMContentLoaded', initMorphExplorer);
document.addEventListener('shopify:section:load', initMorphExplorer);

function initMorphExplorer() {
  const sections = document.querySelectorAll('.cfw-morph-explorer');

  sections.forEach(section => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';

    const tiles = section.querySelectorAll('[data-cfw-tile]');
    const panelWrapper = section.querySelector('[data-cfw-panel]');
    const realPanel = section.querySelector('.cfw-morph-explorer__panel');
    const panelTitle = section.querySelector('[data-cfw-panel-title]');
    const panelDesc = section.querySelector('[data-cfw-panel-desc]');
    const panelBadge = section.querySelector('[data-cfw-panel-badge]');
    const panelLink = section.querySelector('[data-cfw-panel-link]');
    const panelProductsContainer = section.querySelector('[data-cfw-panel-products]');
    const closeBtn = section.querySelector('[data-cfw-close]');

    let activeTileId = null;
    let suppressScroll = false;

    // Helper: Build products HTML
    function getProductsHtml(tileId) {
      const template = document.querySelector(`[data-cfw-products-for="${tileId}"]`);
      return template ? template.innerHTML : '';
    }

    // Close Panel
    function closePanel() {
      if (!activeTileId) return;

      panelWrapper.classList.remove('is-open');
      tiles.forEach(t => t.classList.remove('is-active'));

      activeTileId = null;
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closePanel);
    }

    // Click Tile
    tiles.forEach(tile => {
      tile.addEventListener('click', () => {
        const tileId = tile.dataset.cfwTile;

        // If clicking already active, close it
        if (tileId === activeTileId) {
          closePanel();
          return;
        }

        const isSwitching = activeTileId !== null && panelWrapper.classList.contains('is-open');
        activeTileId = tileId;

        // Update active class on tiles
        tiles.forEach(t => t.classList.remove('is-active'));
        tile.classList.add('is-active');

        // Calculate Anchor X for the connector bridge
        // We measure where the center of the clicked tile is relative to the panel wrapper
        const panelWrapperRect = panelWrapper.getBoundingClientRect();
        const tileRect = tile.getBoundingClientRect();

        // The container might have padding, so we make sure the anchor is within bounds
        let anchorX = (tileRect.left + tileRect.width / 2) - panelWrapperRect.left;

        // Clamp anchorX just in case
        anchorX = Math.max(20, Math.min(anchorX, panelWrapperRect.width - 20));

        realPanel.style.setProperty('--anchor-x', `${anchorX}px`);

        // Prepare new data
        const newTitle = tile.querySelector('.cfw-morph-explorer__tile-title').textContent;
        const descEl = tile.querySelector('.cfw-morph-explorer__tile-desc');
        const newDesc = descEl ? descEl.textContent : '';
        const badge = tile.querySelector('.cfw-morph-explorer__badge');
        const newBadge = badge ? badge.textContent : '';
        const newLink = tile.dataset.collectionUrl;
        const newProductsHtml = getProductsHtml(tileId);

        const updateContent = () => {
          panelTitle.textContent = newTitle;
          if (panelDesc) {
            panelDesc.textContent = newDesc;
            panelDesc.style.display = newDesc ? 'block' : 'none';
          }
          panelBadge.textContent = newBadge;
          panelBadge.style.display = badge ? 'inline-block' : 'none';
          panelLink.href = newLink;
          panelProductsContainer.innerHTML = newProductsHtml;
          initQuickAdds(panelProductsContainer);
        };

        if (isSwitching) {
          // Fade out products, swap, fade in
          panelProductsContainer.style.opacity = '0';
          panelTitle.parentElement.style.opacity = '0';

          setTimeout(() => {
            updateContent();
            panelProductsContainer.style.opacity = '1';
            panelTitle.parentElement.style.opacity = '1';
            panelProductsContainer.classList.add('cfw-anim-fade-up');
            setTimeout(() => panelProductsContainer.classList.remove('cfw-anim-fade-up'), 300);
          }, 200);
        } else {
          updateContent();
          panelWrapper.style.display = 'block';
          // Force reflow
          panelWrapper.offsetHeight;
          panelWrapper.classList.add('is-open');

          panelProductsContainer.classList.add('cfw-anim-fade-up');
          setTimeout(() => panelProductsContainer.classList.remove('cfw-anim-fade-up'), 300);

          // Scroll slightly to make sure panel is in view if on mobile
          setTimeout(() => {
            const panelTop = panelWrapper.getBoundingClientRect().top + window.scrollY;
            // Only scroll if the panel is cut off
            if (!suppressScroll && window.innerHeight < realPanel.offsetHeight + 200) {
               window.scrollTo({ top: panelTop - 120, behavior: 'smooth' });
            }
          }, 350);
        }
      });
    });

    // Handle Arrows (if desktop carousel overflows)
    const prevBtn = section.querySelector('.cfw-collection-carousel__arrow--prev');
    const nextBtn = section.querySelector('.cfw-collection-carousel__arrow--next');
    const track = section.querySelector('.cfw-morph-explorer__tiles-track');

    if (prevBtn && nextBtn && track) {
      const scrollAmount = () => {
        const tile = track.querySelector('.cfw-morph-explorer__tile');
        const gap = parseInt(window.getComputedStyle(track).gap) || 24;
        return tile ? tile.offsetWidth + gap : 300;
      };
      prevBtn.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
      nextBtn.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));

      const updateButtons = () => {
        const isAtStart = track.scrollLeft <= 10;
        const isAtEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;

        prevBtn.disabled = isAtStart;
        nextBtn.disabled = isAtEnd;
      };

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);

      // Delay initial check slightly to allow DOM to render widths
      setTimeout(updateButtons, 100);
    }

    // Auto-open the first tile on load (without scrolling the page)
    if (tiles.length) {
      suppressScroll = true;
      tiles[0].click();
      setTimeout(function () { suppressScroll = false; }, 600);
    }
  });
}


function initQuickAdds(scope) {
  var qas = scope.querySelectorAll('[data-cfw-qa]');
  qas.forEach(function (qa) {
    if (qa.dataset.qaInit) return;
    qa.dataset.qaInit = '1';

    var dataEl = qa.querySelector('[data-cfw-variants]');
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var optNames = (qa.getAttribute('data-opt-names') || '').split('|');
    var idInput = qa.querySelector('[data-cfw-qa-id]');
    var addBtn = qa.querySelector('[data-cfw-qa-add]');
    var toggle = qa.querySelector('[data-cfw-qa-toggle]');
    var panel = qa.querySelector('[data-cfw-qa-panel]');
    var sel = {};

    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var willOpen = panel.hidden;
        panel.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', String(willOpen));
      });
    }

    var optBtns = qa.querySelectorAll('[data-opt][data-val]');
    optBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.getAttribute('data-opt');
        sel[name] = btn.getAttribute('data-val');
        optBtns.forEach(function (b) {
          if (b.getAttribute('data-opt') === name) {
            b.classList.toggle('is-selected', b === btn);
          }
        });
        resolve();
      });
    });

    function resolve() {
      var complete = optNames.every(function (n) { return sel[n]; });
      if (!complete) {
        addBtn.disabled = true;
        addBtn.textContent = 'Select Options';
        if (idInput) idInput.value = '';
        return;
      }
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < optNames.length; j++) {
          if (v.o[j] !== sel[optNames[j]]) { ok = false; break; }
        }
        if (ok) { match = v; break; }
      }
      if (match && match.a) {
        if (idInput) idInput.value = match.id;
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Cart';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = match ? 'Sold Out' : 'Unavailable';
        if (idInput) idInput.value = '';
      }
    }
  });
}
